import { Pipe, PipeTransform } from '@angular/core';
/*
 * Filter object down to matching
 *
 * Usage:
 *   dataArray | filter:"elementId"
 * Example:
 *   {{ [{elementId: 1},...] | filter:"elementId":elementId }}
 *   Returns only matching
*/
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(data: any[], key: string, value: any): any[] {
    return data?.filter(obj => obj[key] === value);
  }
}